import type React from 'react';
import { RatingTooltip } from './RatingTooltip';
import { StarRating } from './StarRating';

export interface BaseLayoutProps {
  reviewLink?: string | null;
  starRating?: number;
  starRatingTooltip?: string;
  hideNumber?: boolean;
  smallRatingText?: boolean;
  wrapRatingText?: boolean;
}

export function BaseLayout({
  reviewLink,
  starRating,
  starRatingTooltip,
  hideNumber = false,
  smallRatingText = false,
  wrapRatingText = false,
}: BaseLayoutProps): React.JSX.Element | string {
  if (!starRating) return 'Not yet rated';

  return (
    <div
      className={`flex ${wrapRatingText ? 'flex-wrap' : 'flex-nowrap'}`}
      data-testid="rating-component"
    >
      <div className="mb-2 flex">
        <StarRating className="mr-[5px]" gap="5px" size="19px" value={starRating} />
        {!hideNumber && starRating !== 0 && (
          <strong className="mx-2 inline-block text-end font-bold">{starRating.toFixed(1)}</strong>
        )}
      </div>
      <span
        className={`${smallRatingText ? 'typography-text-small' : 'typography-text'} whitespace-nowrap`}
      >
        {reviewLink ? (
          <a href={reviewLink} rel="noopener noreferrer" target="_blank">
            NerdWallet rating{' '}
          </a>
        ) : (
          <>NerdWallet rating </>
        )}
        {starRatingTooltip && <RatingTooltip starRatingTooltip={starRatingTooltip} />}
      </span>
    </div>
  );
}
